// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fade-in {
  opacity: 1;
  transition: opacity 0.3s ease;
}

.fade-out {
  opacity: 0;
  transition: opacity 0.4s ease;
}
`, "",{"version":3,"sources":["webpack://./static/CopyToClipboard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B","sourcesContent":[".fade-in {\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.fade-out {\n  opacity: 0;\n  transition: opacity 0.4s ease;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
